import { template } from './template/template';

export const environment = {
  production: true,
  debug: false,
  useGo: true,
  lite: true,
  fast: true,
  isMobile: false,
  customLogin: false,
  isLocal: false,
  template: template,
  apiUrl: 'https://api.schott.valueminer.eu',
  messagingUrl: 'https://schott.valueminer.eu/messaging',
  messagingSocketNamespace: 'https://schott.valueminer.eu',
  messagingSocketPath: '/socket.io',
  exportUrl: 'https://export.schott.valueminer.eu',
  oauthUrl: 'https://oauth.schott.valueminer.eu',
  imageUrl: 'https://oauth.schott.valueminer.eu/profile/?id=',
  fileupload: 'https://oauth.schott.valueminer.eu',
  go: 'https://apigo.schott.valueminer.eu',
  goPrefix: {},
  goSuffix: {},
  app: '',
  s3: 'valueminer.local',
  aws: {
    access_key_id: 'AKIAVQ3RHJYALBWTHAN4',
    access_key_secret: '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',
    s3_bucket: 'valueminer.local',
    s3_region: 'eu-central-1',
  },
  auth: {
    authurl: 'https://oauth.schott.valueminer.eu/oauth/authorize/',
    tokenurl: 'https://oauth.schott.valueminer.eu/oauth/token/',
    logouturl: 'https://oauth.schott.valueminer.eu/wp-login.php?action=logout',
    authorization: {},
    clientID: 'valueminer',
    mobileClientId: 'mobile',
    redirectURL: 'https://schott.valueminer.eu/',
    scopes: ['api', 'users']
  },
  socket: {
    url: 'https://apigo.schott.valueminer.eu',
    path: '/socket.io/'
  },
  design: {
    key: '',
    logo: './assets/svg/logo.green.svg',
    title: 'ValueMiner',
    titleIsImage: false,
    subtitle: '',
    welcomeText: ''
  },
  roleSelection: {
    norole: '/assets/png/schott-norole.png'
  },
  mobileDesign: {}
};
